<template>
    <div v-if="showEndgame && !dismissed"
         class="endgame w-100 h-100">
        <font-awesome-icon class="endgame__close"
                           icon="times"
                           @click.prevent="hidePopup" />
        <div class="endgame__icon mb-5">🎉</div>
        <strong class="endgame__title d-block mb-4 px-5 w-lg-75">{{ endPlayer }} drew the last king!</strong>
        <drawn-kings class="mb-5"></drawn-kings>
        <a href="#"
           @click.prevent="$store.state.room.socket.write('game_end')"
           class="btn btn-primary"
           v-if="isUserHost">Play again</a>
        <p v-else
           style="font-size: 24px;">
            Waiting for the host to start new game
        </p>
    </div>
</template>

<script>
import gtag from '@/mixins/gtag.js';
import DrawnKings from '@/components/DrawnKings.vue';

export default {
    data() {
        return {
            showEndgame: false,
            dismissed: false,
            endPlayer: '',
        };
    },
    components: {
        DrawnKings,
    },
    computed: {
        isUserHost() {
            return (
                this.$store.state.room.host.player_id ===
                this.$store.state.user.player_id
            );
        },
    },
    mounted() {
        document.addEventListener('keyup', (evt) => {
            if (evt.keyCode === 27) {
                this.hidePopup();
            }
        });

        this.$bus.$on('showEndgame', () => {
            setTimeout(() => {
                this.endPlayer = this.$store.state.room.turn.name;
                this.showPopup();

                // Log the event with GA4
                gtag('event', 'show_endgame');
            }, 2000);
        });
    },
    methods: {
        showPopup() {
            this.showEndgame = true;
        },
        hidePopup() {
            this.showEndgame = false;
            this.dismissed = true;
        },
    },
};
</script>

<style></style>
